/**
 * Storage Adapter
 * Transforms storage-related data between API and application layer
 */

import { BaseAdapter } from './base.adapter';
import type {
  StorageUrl,
  GenerateDownloadUrlDto,
  GenerateDeleteUrlDto,
  StorageUrlResponseDto
} from '@/types';

export class StorageAdapter extends BaseAdapter {
  /**
   * Adapts storage URL from API response
   */
  static fromApi(dto: StorageUrlResponseDto): StorageUrl {
    return {
      url: dto.url,
      key: dto.key,
      expiresIn: dto.expiresIn
    };
  }

  /**
   * Adapts generate upload URL request
   * Note: Backend only accepts contentType in body, key as query param
   */
  static toGenerateUploadUrlRequest(
    _fileName: string,
    contentType: string
  ): { contentType: string } {
    // Only return contentType as that's what the backend expects in the body
    return { contentType };
  }

  /**
   * Adapts generate download URL request
   */
  static toGenerateDownloadUrlRequest(key: string): GenerateDownloadUrlDto {
    return { key };
  }

  /**
   * Adapts generate delete URL request
   */
  static toGenerateDeleteUrlRequest(key: string): GenerateDeleteUrlDto {
    return { key };
  }
}
